import _classCallCheck from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// https://github.com/davidtheclark/react-aria-modal/blob/master/src/react-aria-modal.js
import React from "react";
import * as noScroll from "./no-scroll";
import { ReactFocusTrap } from "./focus-trap-react";
import { displace } from "./react-displace";

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _this.getApplicationNode = function () {
      if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
      return _this.props.applicationNode;
    };

    _this.checkUnderlayClick = function (event) {
      if (_this.dialogNode && event.target instanceof Node && _this.dialogNode.contains(event.target) || // If the click is on the scrollbar we don't want to close the modal.
      event.target instanceof Element && event.target.ownerDocument && (event.pageX > event.target.ownerDocument.documentElement.offsetWidth || event.pageY > event.target.ownerDocument.documentElement.offsetHeight)) return;

      _this.exit(event);
    };

    _this.checkDocumentKeyDown = function (event) {
      if (_this.props.escapeExits && (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27)) {
        _this.exit(event);
      }
    };

    _this.exit = function (event) {
      if (_this.props.onExit) {
        _this.props.onExit(event);
      }
    };

    if (!_this.props.titleText && !_this.props.titleId) {
      throw new Error("react-aria-modal instances should have a `titleText` or `titleId`");
    }

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      } // Timeout to ensure this happens *after* focus has moved


      var applicationNode = this.getApplicationNode();
      setTimeout(function () {
        if (applicationNode && applicationNode instanceof Element) {
          applicationNode.setAttribute("aria-hidden", "true");
        }
      }, 0);

      if (this.props.escapeExits) {
        this.addKeyDownListener();
      }

      if (this.props.scrollDisabled) {
        noScroll.on();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
        noScroll.off();
      } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
        noScroll.on();
      }

      if (this.props.escapeExits && !prevProps.escapeExits) {
        this.addKeyDownListener();
      } else if (!this.props.escapeExits && prevProps.escapeExits) {
        this.removeKeyDownListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.scrollDisabled) {
        noScroll.off();
      }

      var applicationNode = this.getApplicationNode();

      if (applicationNode && applicationNode instanceof Element) {
        applicationNode.setAttribute("aria-hidden", "false");
      }

      this.removeKeyDownListener();
    }
  }, {
    key: "addKeyDownListener",
    value: function addKeyDownListener() {
      var _this2 = this;

      setTimeout(function () {
        document.addEventListener("keydown", _this2.checkDocumentKeyDown);
      });
    }
  }, {
    key: "removeKeyDownListener",
    value: function removeKeyDownListener() {
      var _this3 = this;

      setTimeout(function () {
        document.removeEventListener("keydown", _this3.checkDocumentKeyDown);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props;
      var style = {};

      if (props.includeDefaultStyles) {
        style = {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1050,
          overflowX: "hidden",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          textAlign: "center"
        };

        if (props.underlayColor) {
          style.background = props.underlayColor;
        }

        if (props.underlayClickExits) {
          style.cursor = "pointer";
        }
      }

      if (props.underlayStyle) {
        for (var key in props.underlayStyle) {
          if (!props.underlayStyle.hasOwnProperty(key)) continue;
          style[key] = props.underlayStyle[key];
        }
      }

      var underlayProps = {
        className: props.underlayClass,
        style: style
      };

      if (props.underlayClickExits) {
        underlayProps.onMouseDown = this.checkUnderlayClick;
      }

      for (var prop in this.props.underlayProps) {
        underlayProps[prop] = this.props.underlayProps[prop];
      }

      var verticalCenterStyle = {};

      if (props.includeDefaultStyles) {
        verticalCenterStyle = {
          display: "inline-block",
          height: "100%",
          verticalAlign: "middle"
        };
      }

      var dialogStyle = {};

      if (props.includeDefaultStyles) {
        dialogStyle = {
          display: "inline-block",
          textAlign: "left",
          top: 0,
          maxWidth: "100%",
          cursor: "default",
          outline: props.focusDialog ? 0 : undefined
        };

        if (props.verticallyCenter) {
          dialogStyle.verticalAlign = "middle";
          dialogStyle.top = 0;
        }
      }

      if (props.dialogStyle) {
        for (var _key in props.dialogStyle) {
          if (!props.dialogStyle.hasOwnProperty(_key)) continue;
          dialogStyle[_key] = props.dialogStyle[_key];
        }
      }

      var dialogProps = {
        key: "b",
        ref: function ref(el) {
          _this4.dialogNode = el;
        },
        role: props.alert ? "alertdialog" : "dialog",
        id: props.dialogId,
        className: props.dialogClass,
        style: dialogStyle
      };

      if (props.titleId) {
        dialogProps["aria-labelledby"] = props.titleId;
      } else if (props.titleText) {
        dialogProps["aria-label"] = props.titleText;
      }

      if (props.focusDialog) {
        dialogProps.tabIndex = -1;
      } // Apply data- and aria- attributes passed as props


      for (var _key2 in props) {
        if (/^(data-|aria-)/.test(_key2)) {
          dialogProps[_key2] = props[_key2];
        }
      }

      var childrenArray = [React.createElement("div", Object.assign({}, dialogProps), props.children)];

      if (props.verticallyCenter) {
        childrenArray.unshift(React.createElement("div", {
          key: "a",
          style: verticalCenterStyle
        }));
      }

      var focusTrapOptions = props.focusTrapOptions || {};

      if (props.focusDialog || props.initialFocus) {
        focusTrapOptions.initialFocus = props.focusDialog ? "#".concat(this.props.dialogId) : props.initialFocus;
      }

      focusTrapOptions.escapeDeactivates = props.escapeExits;
      return React.createElement(ReactFocusTrap, {
        focusTrapOptions: focusTrapOptions,
        paused: props.focusTrapPaused
      }, React.createElement("div", Object.assign({}, underlayProps), childrenArray));
    }
  }]);

  return Modal;
}(React.Component);

Modal.defaultProps = {
  underlayProps: {},
  dialogId: "react-aria-modal-dialog",
  underlayClickExits: true,
  escapeExits: true,
  underlayColor: "rgba(0,0,0,0.5)",
  includeDefaultStyles: true,
  focusTrapPaused: false,
  scrollDisabled: true
};
var AriaModal = displace(Modal);

AriaModal.renderTo = function (input) {
  return displace(Modal, {
    renderTo: input
  });
};

export default AriaModal;